module.exports = __webpack_public_path__ + "static/media/blue-card-6.f5ab7661.png";